export default "__VITE_ASSET__CfpIDwE2__"